import { render } from "./ShopProfileSkeleton.vue?vue&type=template&id=1c1bae56"
import script from "./ShopProfileSkeleton.vue?vue&type=script&lang=js"
export * from "./ShopProfileSkeleton.vue?vue&type=script&lang=js"

import "./ShopProfileSkeleton.vue?vue&type=style&index=0&id=1c1bae56&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__